const workbench = () => import('@/view/workbench/index')
const memberData =() => import("@/view/workbench/memberData");
const marketingData =() => import("@/view/workbench/marketingData");
const assistant =() => import("@/view/workbench/assistant");
const realTimeData =() => import("@/view/workbench/realTimeData");
let router = [
    {
      path: '/workbench',
      component: workbench,
      name: 'workbench',
      redirect:"/workbench/realTimeData",
      meta: {
        menuTitle: "工作台",
        menuKey: "workbench",
        menuIcon: "icon-workbench",
      },
      children:[
        {
          path:'dataOverview',
          component:workbench,
          name:"dataOverview",
          meta:{
            menuKey:"workbench",
            menuTitle: "数据概览",
            menuIcon: "el-icon-monitor",
          },
          children:[
            {
              path:"/workbench/realTimeData",
              component:realTimeData,
              name:'realTimeData',
              meta:{
                menuKey:"workbench",
                menuTitle: "实时数据",
                menuIcon: "el-icon-chat-dot-round",
                // secondMenuKey: 'autoPullDetail'
              }
            },
            {
              path:"/workbench/memberdata",
              component:memberData,
              name:'memberData',
              meta:{
                menuKey:"workbench",
                menuTitle: "会员数据",
                menuIcon: "el-icon-chat-dot-round",
                // secondMenuKey: 'autoPullDetail'
              }
            },
            
            {
              path:"/workbench/marketingdata",
              component:marketingData,
              name:'marketingData',
              meta:{
                menuKey:"workbench",
                menuTitle: "营销数据",
                menuIcon: "el-icon-chat-dot-round",
              }
            },
          ]
        },
        {
          path:'dataOverview',
          component:workbench,
          name:"dataOverview",
          meta:{
            menuKey:"workbench",
            menuTitle: "智能分析",
            menuIcon: "el-icon-monitor",
          },
          children:[
            {
              path:"/workbench/assistant",
              component:assistant,
              name:'assistant',
              meta:{
                menuKey:"workbench",
                menuTitle: "积木云助手",
                menuIcon: "el-icon-chat-dot-round",
                // secondMenuKey: 'autoPullDetail'
              }
            },
          ]
        }
      ]
    }
  ]
  export default router